const ONE_HOUR = 1000 * 60 * 60;
export const DEFAULT_QUERY_OPTIONS = {
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  keepPreviousData: true,
  staleTime: ONE_HOUR
};
